export const GET_PRODUCTS = 'GET_PRODUCTS';
export const GET_PRODUCT = 'GET_PRODUCT';
export const GET_PRODUCT_BY_CODE = 'GET_PRODUCT_BY_CODE';
export const REDUCE_PRODUCTS = 'REDUCE_PRODUCTS';
export const REDUCE_PRODUCT = 'REDUCE_PRODUCT';
